import { ThemeIconProps, ThemeIcon } from "@mantine/core"
import { IconCheck, IconX, IconSquare } from "@tabler/icons-react"
import { match } from "ts-pattern"
import { WorkflowResult } from "../../@client/Absents"

interface Props extends ThemeIconProps {
  status: WorkflowResult
  showPending?: boolean
  shade?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9
  isActive?: boolean
}

export const AbsentApprovalStatusIcon = React.forwardRef<HTMLDivElement, Props>(
  function ({ isActive, status, shade, showPending, ...props }, ref) {
    const getColor = (baseColor: string) =>
      `${baseColor}${shade ? `.${shade}` : ""}`

    const iconProps = match(status)
      .returnType<ThemeIconProps>()
      .with({ Case: "Approved" }, () => ({
        color: getColor("green"),
        variant: "filled",
        children: <IconCheck />,
      }))
      .with({ Case: "Rejected" }, () => ({
        color: getColor("red"),
        variant: "filled",
        children: <IconX />,
      }))
      .with({ Case: "Canceled" }, () => ({
        color: getColor("gray"),
        children: <IconX />,
      }))
      .with({ Case: "Pending" }, () => {
        if (showPending === false) return { children: null }
        return {
          variant: isActive ? "light" : "default",
          children: <IconSquare />,
        }
      })
      .exhaustive()

    if (!iconProps.children) return null

    return (
      <ThemeIcon
        ref={ref}
        bd="none"
        radius="xl"
        px={4}
        {...props}
        {...iconProps}
      />
    )
  }
)

AbsentApprovalStatusIcon.displayName = "AbsentApprovalStatusIcon"
